import superagent from 'superagent';
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {v4 as uniqueId} from 'uuid';
import {capitalize} from '../util/capitilize';
import {getValueOfFeature, pimText} from '../util/values';

export const fetchConfiguration = createAsyncThunk(
	'configuration/configurationLoading',
	(key, {getState}) => superagent
			.get(`${getState().status.apiUrl}/configuration/${key ?? getState().status.dataKey}`)
			.set('Accept', 'application/json')
			.then((response) => response.body)
			.catch((error) => error)
);

export const storeConfiguration = createAsyncThunk(
	'configuration/store',
	async (options, {getState}) => {
		const state = getState();
		return superagent
			.put(`${getState().status.apiUrl}/configuration/${getState().status.dataKey}`)
			.send({configuration: buildConfiguration(state)})
			.set('Accept', 'application/json')
			.then((response) => response.body)
			.catch((error) => error);
	}
);

const configurationInitialState = {
	status: 'idle',
	data: {
		formatVersion: 18,
		dataKey: '',
		rootKey: '',
		changesCount: 0,
		projects: [
			{
				key: '',
				name: '',
				configuration: null,
				sort: 1,
				created: null,
				updated: null,
				project: {
					source: 'external',
					lastPersistedBy: 'External',
					anonymousUserId: '',
					featureModelId: '',
					productModelId: '',
					ready: false,
					valid: false,
					lang: 'de',
					name: '',
					region: 'int',
					decisions: {
						features: [
						]
					},
					lightProfileData: null,
					solarData: null,
					dimmLevelData: null,
				},
			}
		]
	},
	error: {},
};
export const configurationSlice = createSlice({
	name: 'configuration',
	initialState: configurationInitialState,
	reducers: {
		setFeatureModel: (state, action) => {
			state.data.projects[0].project.featureModelId = action.payload.featureModel;
		},
		setProductModel: (state, action) => {
			state.data.projects[0].project.productModelId = action.payload.productModel;
		},
		setDecisions: (state, action) => {
			state.data.projects[0].project.decisions = action.payload;
		},
		setDimmLevel: (state, action) => {
			console.log('setDimmLevel', action.payload);
			state.data.projects[0].project.dimmLevelData = action.payload;
		},
		downloadCSV: (state, action) => {
			const project = state.data.projects[0].project;
			const projectName = project.info?.projectName || 'decisions';
			const exportDecisions = Object.assign({}, state.data.projects[0].project.decisions);
			exportDecisions.project = state.data.projects[0].project.decisions;
			downloadAsCSV(action.payload.csvContent, projectName);
		}
	},
	extraReducers: (builder) => {
		builder.addCase(fetchConfiguration.fulfilled, (state, action) => {
			console.log('fetchConfiguration.fulfilled', action.payload.status);
			if (action.payload.status === 404) {
				state.data = configurationInitialState.data;
			} else {
				state.data = action.payload.data;
			}
			state.status = 'idle';
			state.error = {};
		});
		builder.addCase(fetchConfiguration.pending, (state, action) => {
			//state.data = {};
			state.status = 'loading';
			state.error = {};
		});
		builder.addCase(fetchConfiguration.rejected, (state, action) => {
			//state.data = {};
			state.status = 'idle';
			state.error = action.payload;
		});
		builder.addCase(storeConfiguration.fulfilled, (state, action) => {
			//state.data = action.payload.data;
			//state.status = 'idle';‚
			//state.error = {};
		});
		builder.addCase(storeConfiguration.pending, (state, action) => {
			//state.data = [];
			//state.status = 'loading';
			//state.error = {};
		});
		builder.addCase(storeConfiguration.rejected, (state, action) => {
			//state.data = [];
			//state.status = 'idle';
			//state.error = action.payload;
		});
	}
});

//sends csvContent Array as csv file to browser
function downloadAsCSV(csvContent, name) {
		const separator = ';';

		const csv = 'data:text/csv;charset=utf-8,' +
			csvContent.map(row => row.join(separator)).join('\n');

		const downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute('href', encodeURI(csv));
        downloadAnchorNode.setAttribute('download', name + '.csv');
        document.body.appendChild(downloadAnchorNode);
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
}


function buildConfiguration(state) {

	// create decisions from current decision state when available, otherwise use loaded configuration
	const decisionDecisions = state.decisions?.data?.decisions;
	const featureModelId = state.configuration?.data?.projects[0]?.project?.featureModelId;
	const productModelId = state.configuration?.data?.projects[0]?.project?.productModelId;
	const configurationDecisions = state.configuration?.data?.projects[0]?.project?.decisions?.features;
	const lightProfileData = {
		project:  state.lightProfile.data.project,
	};
	const solarData = {
		project:  state.solar.data.project,
	};
	const dimmLevelData = state.configuration?.data?.projects[0]?.project?.dimmLevelData;
	const decisions = decisionDecisions.length > 0 ? decisionDecisions : configurationDecisions ?? [];

	return {
		formatVersion: 18,
		dataKey: state.status.dataKey,
		rootKey: state.status.rootKey ?? state.status.dataKey,
		changesCount: state.configuration.data.changesCount + 1,
		projects: [
			{
				key: state.status.dataKey,
				name: state.configuration.data.name ?? '',
				sort: state.configuration.data.sort ?? 1,
				project: {
					lang: state.status.lang,
					region: state.status.region,
					key: state.status.dataKey,
					name: state.configuration.data.name ?? '',
					lastPersistedBy: capitalize(state.status.mode),
					source: capitalize(state.status.mode),
					featureModelId: featureModelId,
					productModelId: productModelId,
					ready: true,
					valid: state.decisions.data.isSatisfied,
					sort: 1,
					decisions: {features: decisions},
					lightProfileData: lightProfileData,
					solarData: solarData,
					dimmLevelData: dimmLevelData,
					info: {
					}
				}
			}
		]
	};
}

export const {
	setFeatureModel,
	setProductModel,
	setLocation,
	setDecisions,
	setDimmLevel,
	downloadCSV,
} = configurationSlice.actions;


export default configurationSlice.reducer;
